import { render, staticRenderFns } from "./rt-sort.vue?vue&type=template&id=45c64b04&"
import script from "./rt-sort.vue?vue&type=script&lang=js&"
export * from "./rt-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports